import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { criarFiltroMarca } from '../utils/marca'

/**
 * Hook responsável por filtrar uma lista com base nas marcas selecionadas.
 *
 * O filtro é aplicado apenas aos itens que possuem a propriedade
 * `marcaConfiguracao`. Itens sem essa propriedade são mantidos na lista;
 * itens com marca vazia entram apenas quando "Sem marca" está selecionada.
 *
 * @param {Array} list Lista de itens a ser filtrada.
 * @returns {Array} Lista filtrada conforme as marcas selecionadas.
 */
export default function useTrademarkListFilter(list) {
    const selectedTrademarks = useSelector((state) => state.trademark.selecteds)

    const filteredList = useMemo(() => {
        if (!list || !selectedTrademarks.length) {
            return list
        }

        return list.filter(criarFiltroMarca(selectedTrademarks))
    }, [list, selectedTrademarks])

    return filteredList
}